<template>
  <div class="tree-menu" :class="treeClasses">
    <div v-if="depth == 2" class="signal-light__label" :style="'background-color:' + getColor(score)"></div>
    <div class="label-wrapper" @click="toggleChildren" :class="firstLabelClass">
      <div :class="labelClasses" class="d-flex justify-space-between align-center">
        <span v-if="nodes" class="'mw-75'" style="{color:
        var(--gray-color);}
">{{ label }}</span>
        <span v-else class="mw-75 text-description question pointer"
              style="{color:var(--gray-color);}"
              @click="handleClick">{{ label }}</span>
        <div class="d-flex flex-row justify-center align-center">
<!--          <div v-if="score && depth == 1" class="tree-menu__score d-flex justify-center">-->
<!--            <div class="signal-light__bg" :style="'background:' + getColor(score)"></div>-->
<!--            <div class="d-flex flex-row justify-center align-center">-->
<!--              <v-icon class="signal-light" :color="getColor(score)" small>mdi-circle</v-icon>-->
<!--              <span :style="'color:'+ getColor(score)" class="font-weight-bold ml-1">{{ score }}</span>-->
<!--            </div>-->
<!--          </div>-->
          <div v-if="score && depth >= 2" class="">
            <div class="d-flex flex-row justify-center align-center" :style="depth == 4 ?
            'margin-right: 20px;'
            :''">
              <v-icon v-if="depth != 4" class="signal-light" :color="getColor(score)" small>mdi-circle</v-icon>
              <span :style="'color:'+ getColor(score)" class="font-weight-bold ml-1">{{ score }}</span>
            </div>
          </div>
          <v-icon v-if="nodes" :color="depth == 0 ? 'primary' : 'gray_3'">{{ iconClasses }}</v-icon>
        </div>
      </div>
    </div>
    <div :class="treeContainerClasses">
      <tree-menu
          v-if="showChildren"
          v-for="node in nodes"
          :currentNode="node"
          :nodes="getNodes(node)"
          :label="getLabel(node)"
          :key="node"
          :score="getScore(node)"
          :depth="depth + 1"
          :eventBus="eventBus"
      >
      </tree-menu>
    </div>
  </div>
</template>
<script>
  export default { 
  name: 'tree-menu',
  props: [ 'nodes', 'label', 'score', 'depth', 'currentNode', 'eventBus' ],
  data() {
     return {
       showChildren: false,
       questionDisplay:false,
       showTree: false,
     }
  },
  computed: {
    treeClasses() {
      if(this.depth == 1) {
        return "parent-card"
      } else if(this.depth == 2) {
        return "child-card__container"
      }
    },
    treeContainerClasses() {
      if(this.depth == 1) {
        return "depth-1"
      } else if(this.depth == 2) {
        return "depth-2"
      } else if(this.depth == 3) {
        return "depth-3"
      }
    },
    iconClasses() {
      if(!this.showChildren) {
        if (this.depth == 1) {
          return "mdi-signal"
        } else if (this.depth == 2) {
          return "expand_more"
        } else{
          return "mdi-menu-down"
        }
      }else{
        if(this.depth == 1) {
          return "mdi-signal"
        } else if (this.depth == 2){
          return "expand_less"
        } else{
          return "mdi-menu-up"
        }
      }
      // if(!this.showChildren){ return "mdi-menu-down" }
      // else{ return "mdi-menu-up" }
    },
    labelClasses() {
      if(this.nodes){
          return 'has-children'
      }
    },
    firstLabelClass() {
      if(this.depth == 0){
          return 'toggle-btn';
      } else if(this.depth == 1){
        return 'label__container'
      }
    },
  },
  methods: {
    open(index) {
      let cards = document.querySelectorAll('.parent-card');
      for (let card in cards) {
        if (typeof cards[card] == 'object') {
          cards[card].style.visibility = 'hidden';
        }
      }
      return cards[index].style.visibility = 'visible';
    },
    close() {
    },
    getScore(node){
      return node.score;
    },
    getLabel(node){
      return node.node.name;
    },
    getNodes(node){
      return node.children;
    },
    toggleChildren() {
      if (this.depth != 1){
        this.showChildren = !this.showChildren;
      }
    },
    getColor(data){
        if(data <=2) return "var(--green-color)";
        if(data <=4) return "var(--yellow-color)";
        return "var(--red-color)";
    },
    handleClick(){
      if(this.currentNode.children == null){
        this.eventBus.$emit("evaluateQuestion", this.currentNode.id);
      }
    },
  }
}
</script>
<style scoped>
.question{
  cursor: pointer;
}
</style>
